import React from 'react'
import './Details.css'
import StdPerfTable from '../Performance/StdPerfTable'
import MonthEndPerfTable from '../Performance/MonthEndPerfTable'
import CalYearPerfTable from '../Performance/CalYearPerfTable'
import CompText from '../Compliance/CompText'
import { useSelector } from 'react-redux'
import DetailsTable from './DetailsTable'
import i18n from '../../../i18n';

const Details = () => {
  const data = useSelector(state => state.fundData.data)
  const hasLevels = data.filter(x => x.levels !== null);
  const hasPerfData = hasLevels.length > 0
  

  if (!hasPerfData){
    return(
      <div>
        <div className='noData'>{i18n.t('no-data')}</div>
        <CompText pane='Details' />
      </div>
    )
  }

  return (
    <div>
      <div style={{ marginBottom: '65px' }} />
      <div className='fund-char-details'>
        <DetailsTable />
        <div style={{ marginBottom: '65px' }} />
        <StdPerfTable />
        <div style={{ marginBottom: '65px' }} />
        <MonthEndPerfTable />
        <div style={{ marginBottom: '65px' }} />
        <CalYearPerfTable />
        <div style={{ marginBottom: '65px' }} />
        <CompText pane='Details' />
      </div>
    </div>
  )
}

export default Details
